"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = withChildrenIfStaticBuild;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var isStaticBuild = typeof document === 'undefined';

function withChildrenIfStaticBuild(BaseComponent) {
  function WithChildrenIfStaticBuildWrapper(wProps) {
    return isStaticBuild ? wProps.children : /*#__PURE__*/_react.default.createElement(BaseComponent, wProps);
  }

  process.env.NODE_ENV !== "production" ? WithChildrenIfStaticBuildWrapper.propTypes = {
    children: _propTypes.default.node
  } : void 0;
  WithChildrenIfStaticBuildWrapper.defaultProps = {
    children: null
  };
  return WithChildrenIfStaticBuildWrapper;
}